module.exports = __webpack_public_path__ + "static/b5-d8f035ee8860eaca269d86584a28b62d.jpg";